import React, { useState, useEffect } from 'react';
import './HomeLoanDetails.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getBtLoan } from '../../../../common/constants/api';
import {
  faRupeeSign,
  faPaperclip,
  faPlusCircle
} from '@fortawesome/pro-solid-svg-icons';
import { numberFormat } from '../../../../common/constants/NumberFormat';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import RadioButton from '../../../../components/Dashboard-res/CommonComponent/RadioButton';
function HomeLoanCards(props) {
  const {
    values,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    setFieldTouched,
    handleSubmit,
    setSteps,
    setDataView,
    setShow,
    setPopUpType,
    setPopUpText,
    setIndexVal,
    setGetShowButton,
    setTogetdata,
    setBtnEnable
  } = props;
  const [loanData, setLoanData] = useState([]);
  useEffect(() => {
    setShow(true);
    setPopUpType('loading');
    setPopUpText('Fetching the Loan Details ...');
    let applicant = getApplicantionInfo();
    getBtLoan(applicant.leadId)
      .then(res => {
        setLoanData(res);
        setShow(false);
        if (res.length > 0) setGetShowButton(false);
      })
      .catch(err => {
        setPopUpType('fail');
        setPopUpText(
          err?.response?.data?.message ||
            'something gone wrong!please try again..'
        );
      });
  }, []);
  const addMoreLoan = () => {
    setSteps('showLoanDetails');
  };
  const loanDetailsView = (data, i) => {
    setIndexVal(i);
    setSteps('showLoanDetailsView');
  };
  const onHomeLoan = data => {
    setFieldValue('homeloan', data.id);
    setBtnEnable(true);
    setTogetdata([data]);
  };
  return (
    <React.Fragment>
      <div className="flex w-full relative m-auto mt-2 loan-bar md:p-2">
        <div className="w-6/12 text-black-400 font-bold">Choose Home Loans</div>
      </div>
      {loanData.length > 0 ? (
        loanData.map((data, i) => {
          return (
            <div className="card_items mt-4 md:w-5/12 m-2 float-left">
              <p className="font-roboto font-normal text-sm text-green-900 py-2">
                Loan {i + 1}
              </p>
              <div
                className={`loan_cards p-2 md:5/12 text-black-400 `}
                onClick={() => onHomeLoan(data)}
              >
                <div className="flex w-full">
                  <div className="w-6/12 text-black-400">
                    <span className="px-1 float-left">
                      {/*<img src="" alt="Loan Icon" />*/}
                    </span>
                    <span className="px-1 float-left">{data.lender}</span>
                  </div>
                  <div className="flex w-6/12 justify-end">
                    <RadioButton
                      name="homeloan"
                      id="homeloan"
                      value={data.id}
                      checked={values.homeloan == data.id}
                      onChange={e => {
                        handleChange(e);
                        onHomeLoan(data);
                      }}
                      onBlur={e => {
                        handleBlur(e);
                      }}
                    />
                  </div>
                </div>
                <div className="flex w-full mt-4">
                  <div className="w-full">
                    <div className="w-full text-grey-600  text-sm">
                      Balance Amount
                    </div>
                    <div className="w-full text-green-1100 font-bold  text-xs">
                      <FontAwesomeIcon icon={faRupeeSign} />{' '}
                      {numberFormat(data.balanceAmount)}
                    </div>
                  </div>
                </div>
                <div className="flex w-full mt-4">
                  <div className="w-6/12">
                    <div className="w-full text-grey-600 text-sm">
                      Sanction Amount
                    </div>
                    <div className="w-full font-bold text-xs">
                      <FontAwesomeIcon icon={faRupeeSign} />{' '}
                      {numberFormat(data.sanctionAmount)}
                    </div>
                  </div>
                  <div className="w-6/12">
                    <div className="w-full text-grey-600 text-sm">
                      Current EMI
                    </div>
                    <div className="w-full font-bold text-xs">
                      <FontAwesomeIcon icon={faRupeeSign} />
                      {numberFormat(data.currentEmi)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="w-full text-black-400 text-sm text-center">
          You don't have any existing Home Loan.
        </div>
      )}
    </React.Fragment>
  );
}
export default HomeLoanCards;
